<template>
      <div no-body class="lku-coa"> 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><span class="pt-2 mr-3">Filter</span></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCoa"
          responsive
          striped hover
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc" 
          :key="updatetable" 
          :filter="filter"
          @filtered="onFiltered"                
          @row-clicked="selectItem"
        >
        <template v-slot:cell(kodeacc)="data">
          <span v-if="(data.item.judul=='Y')" style="font-weight:bold;" :style="`margin-left:${data.item.level_*5}px`"> {{data.item.kodeacc}}</span>
          <span v-else :style="`margin-left:${data.item.level_*5}px`">{{data.item.kodeacc}}</span>
        </template>
        <template v-slot:cell(namaacc)="data">
          <span v-if="(data.item.judul=='Y')" style="font-weight:bold;" :style="`margin-left:${data.item.level_*5}px`"> {{data.item.namaacc}}</span>
          <span v-else :style="`margin-left:${data.item.level_*5}px`">{{data.item.namaacc}}</span>
        </template>

        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-coa {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crud from "../../apis/crud";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "kodeacc",
            label: "Account Code",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "namaacc",
            label: "Account Name",
            sortable: true
          },
          {
            key: "typeacc",
            thStyle: "width:100px",
            label: "Type"
          },
      ],
      items:[],
      tblData: {
        items:[],
        tablename:'job-department',
        page: 1,
        total: 0,
        sortBy: 'departkd',
        sortDesc: false
      },
      updatetable:false,
      filter:null
    };
  },
  props: ["lookupdata"],
  created: async function() {
      this.tblData.items = this.lookupdata || [];    
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    selectItem(item,index) {
        if (item.judul!=='Y'){
          this.$emit("click", item);
        } else {
          toastr.warn('Account punya anak tidak boleh dipilih!');
        }
    },  
    refresh() {
      this.$refs.tblCoa.refresh();
    }
  }
};
</script>
